import { defineStore, storeToRefs } from "pinia"
import { computed } from "vue"
import { Activity } from "@/models/activity.model"
import { useWorkPeriodStore } from "@/store/work-periods.store.ts"
import { useRelatedObjectsManager } from "@/composables/socket/related-objects-manager.ts"
import type { WorkPeriod } from "@/models/work-period.model.ts"

export const useActivityStore = defineStore("activityStore", () => {
  const workPeriodStore = useWorkPeriodStore()
  const { appWorkPeriods, workPeriods } = storeToRefs(workPeriodStore)

  /**
   * The activities / breaks of the app user.
   */
  const appActivities = computed(() =>
    appWorkPeriods.value.flatMap((workPeriod) => workPeriod.activities)
  )
  /**
   * The activities / breaks of the service provider.
   */
  const activities = computed(() =>
    workPeriods.value.flatMap((workPeriod) => workPeriod.activities)
  )

  // Receive socket updates for activities
  const {
    pushToRelatedObjects: pushToRelatedAppWorkPeriod,
    removeFromRelatedObjects: removeFromRelatedAppWorkPeriod
  } = useRelatedObjectsManager(
    appWorkPeriods,
    (activity: Activity) => activity.workPeriod,
    (workPeriod: WorkPeriod) => workPeriod.id,
    (workPeriod: WorkPeriod) => workPeriod.activities
  )

  const {
    pushToRelatedObjects: pushToRelatedWorkPeriod,
    removeFromRelatedObjects: removeFromRelatedWorkPeriod
  } = useRelatedObjectsManager(
    workPeriods,
    (activity: Activity) => activity.workPeriod,
    (workPeriod: WorkPeriod) => workPeriod.id,
    (workPeriod: WorkPeriod) => workPeriod.activities
  )

  return {
    activities,
    appActivities,
    pushToRelatedWorkPeriod,
    removeFromRelatedWorkPeriod,
    pushToRelatedAppWorkPeriod,
    removeFromRelatedAppWorkPeriod
  }
})
